/**
 * Desactivar la plantilla PREDETERMINADA: exige elegir otra predeterminada (o advierte
 * que el sistema elegirá automáticamente la activa más reciente del mismo alcance).
 */
import { useState } from "react";
import { WarningIcon, XIcon } from "@phosphor-icons/react";
import { useModalForm } from "@/lib/modalForm";
import BotonCerrar from "@/components/BotonCerrar";

export default function DeactivateDefaultModal({ template, candidates, onConfirm, onClose }) {
  const [nueva, setNueva] = useState(candidates[0]?.id || "");
  const vm = useModalForm({ onClose: onClose, abierto: Boolean(template) });
  if (!template) return null;
  return (
    <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4" data-testid="deactivate-default-modal" {...vm.overlayProps}>
      <div className="bg-card border border-border rounded-lg w-full max-w-md p-5">
        <div className="flex items-center justify-between mb-3">
          <h3 className="font-heading text-lg flex items-center gap-2">
            <WarningIcon size={18} className="text-agro-yellow" /> Desactivar predeterminada
          </h3>
          <button aria-label="Cerrar" onClick={vm.cerrar} className="text-text-muted hover:text-white"><XIcon size={18} /></button>
        </div>
        <p className="text-sm text-text-secondary mb-3">
          &quot;{template.nombre}&quot; es la plantilla predeterminada. Elige cuál la reemplazará para que
          los documentos sigan generándose con una plantilla activa.
        </p>
        {candidates.length === 0 ? (
          <p className="text-xs text-amber-400">No hay otra plantilla activa de este tipo. Activa o crea otra primero.</p>
        ) : (
          <select value={nueva} onChange={(e) => setNueva(e.target.value)} data-testid="new-default-select"
            className="w-full bg-background border border-border rounded px-2 py-1.5 text-sm mb-4">
            {candidates.map((c) => (
              <option key={c.id} value={c.id}>{c.nombre} (v{c.version}) · {c.alcance === "sucursal" ? "Sucursal" : "Empresa"}</option>
            ))}
          </select>
        )}
        <div className="flex justify-end gap-2">
          <button onClick={vm.cerrar} className="px-3 py-1.5 text-sm border border-border rounded">Cancelar</button>
          <button onClick={() => onConfirm(nueva)} disabled={candidates.length === 0} data-testid="confirm-deactivate"
            className="px-3 py-1.5 text-sm rounded bg-agro-green text-black font-semibold disabled:opacity-50">
            Desactivar y usar la seleccionada
          </button>
        </div>
      </div>
    </div>
  );
}
